module.exports = __webpack_public_path__ + "static/media/icon-profissionais.12a10b51.svg";